module.exports = __webpack_public_path__ + "static/media/smRound.6445fd32.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/smRound.png
// module id = 683
// module chunks = 0 1